import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "react-router-scroll-to-top";
import Layout from "./components/layout/layout";
import { ForgottenPasswordSendMail } from "./views/common-views/forgotten-password-send-mail";
import PrivateRoute from "./helpers/private-route";
import { UserRoles } from "./types/user-roles";
import Home from "./views/common-views/home/home";
import NotFound from "./views/common-views/not-found/not-found";
import { ThankYouPage } from "./views/common-views/thank-you-page";
import { ForgottenPasswordUpdate } from "./views/common-views/forgotten-password-update";
import { Login } from "./views/common-views/login";
import { AboutUs } from "./views/common-views/about-us";

import { url, urlClient, urlOperator, urlSubcontractor } from "./utils/url";
import { Offer } from "./views/common-views/offer";
import { Faq } from "./views/common-views/faq";

import { Regulations } from "./views/common-views/regulations";
import { PrivacyPolicy } from "./views/common-views/privacyPolicy";
import { Contact } from "./views/common-views/contact";
import "mapbox-gl/dist/mapbox-gl.css";

import { OfferForm } from "./views/common-views/offer-form";
import { OfferFormSummary } from "./views/common-views/offer-form-summary";

import { OfferFormLogged } from "./views/client-views/offer-form";
import { OfferFormSummaryLogged } from "./views/client-views/offer-form-summary";
import OfferFormCreate from "./views/common-views/offer-form-create";

import OperatorClients from "./views/operator-views/operator-clients";

import OperatorOrders from "./views/operator-views/operator-orders";

import OperatorUsers from "./views/operator-views/operator-users";
import OperatorWarehousesPricelist from "./views/operator-views/operator-warehouses-pricelist";

import OperatorSubcontractors from "./views/operator-views/operator-subcontactors";
import { OperatorSubcontractorsDetails } from "./views/operator-views/operator-subcontractors-details";

import OperatorWarehousesServices from "./views/operator-views/operator-warehouses-services";
import SubcontractorsStorageArea from "./views/operator-views/operator-subcontractors-storage-area";
import SubcontractorsStorageAreaAvailability from "./views/operator-views/operator-subcontractors-storage-area/storage-area-availability";
import { OperatorOrdersDetails } from "./views/operator-views/operator-orders-details";
import OperatorClientsEdit from "./views/operator-views/operator-clients-edit";

import OperatorWarehouseDelete from "./views/operator-views/operator-warehouse-delete";

import { ClientAccount } from "./views/client-views/account";

import OperatorOrdersOffering from "./views/operator-views/operator-orders-offering";
import { OfferView } from "./views/client-views/offer-view";
import OperatorWarehousesPricelistEdit from "./views/operator-views/operator-warehouses-pricelist-edit";
import AddAvailabilityForm from "./views/operator-views/operator-subcontractors-storage-area/storage-area-availability-add";
import { OperatorSubcontractorsAdd } from "./views/operator-views/operator-subcontractors-add copy";
import UpdateAvailabilityForm from "./views/operator-views/operator-subcontractors-storage-area/storage-area-availability-edit";
import OfferingPositionEdit from "./views/operator-views/operator-orders-offering/components/position-edit/offering-edit-position";
import OfferingOfferEdit from "./views/operator-views/operator-orders-offering/components/offer-edit/offering-edit-offer";
import PotentialWarehousesList from "./views/operator-views/operator-orders-offering/components/potential-warehouses/potential-warehouses-list";
import OfferingPositionAdd from "./views/operator-views/operator-orders-offering/components/position-add/offering-add-position";
import { Settings } from "./views/client-views/settings";
import OperatorWarehousesPricelistAdd from "./views/operator-views/operator-warehouses-pricelist-add";
import OperatorUserAdd from "./views/operator-views/operator-users-add";
import ClientAddForm from "./views/operator-views/operator-users-add/ClientAddForm";
import AddressAddForm from "./views/operator-views/operator-users-add/AddressAddForm";
import EditUserLogin from "./views/operator-views/operator-users-edit/EditUserLogin";
import EditUserOperatorDataForm from "./views/operator-views/operator-users-edit/EditUserOperatorData";
import EditUserSubcontractorData from "./views/operator-views/operator-users-edit/operator-users-edit-subcontractor/EditUserSubcontractorData";
import StorageAreaAdd from "./views/operator-views/operator-subcontractors-storage-area/storage-area-add";
import StorageAreaEdit from "./views/operator-views/operator-subcontractors-storage-area/storage-area-edit";
import ClientOrders from "./views/client-views/orders";
import StorageAreaPackageAdd from "./views/operator-views/storage-area-packages/packages-add/package-add";
import StorageAreaPackageEdit from "./views/operator-views/storage-area-packages/packages-edit/package-edit";
import { OfferViewFromEmailClientUnlogged } from "./views/client-views/offer-view-from-email/offer-view-from-email-client-unlogged";
import { OfferViewFromEmailClientLogged } from "./views/client-views/offer-view-from-email/offer-view-from-email-client-logged";
import { FinalOfferFromEmailClientUnlogged } from "./views/client-views/offer-view-from-email/final-offer-from-email-client-unlogged";
import { FinalOfferFromEmailClientLogged } from "./views/client-views/offer-view-from-email/final-offer-from-email-client-logged";
import OfferInitialAcceptance from "./views/common-views/offer-initial-acceptance";
import { ClientOrdersDetails } from "./views/client-views/order-details";
import { OfferViewInClientPanel } from "./views/client-views/offer-view-in-client-panel";
import { FinalOfferViewInClientPanel } from "./views/client-views/offer-view-in-client-panel-final";
import SubcontractorSubcontractors from "./views/subcontactor-views/subcontractors";
import { SubcontractorsDetails } from "./views/subcontactor-views/subcontractors/subcontractors-details";
import WarehousesServices from "./views/subcontactor-views/subcontractors/warehouses-services";
import WarehousesPricelist from "./views/subcontactor-views/subcontractors/warehouses-pricelist";
import SubcontractorStorageArea from "./views/subcontactor-views/subcontractors/operator-subcontractors-storage-area";
import StorageAreaAvailability from "./views/subcontactor-views/subcontractors/operator-subcontractors-storage-area/storage-area-availability";
import { WarehousesGalleryView } from "./views/operator-views/operator-subcontractors-warehouses-gallery";
import { SubcontractorOfferView } from "./views/subcontactor-views/offer-view-subcontractor";

//TOO DOO

const App = () => {
  return (
    <Router>
      <ScrollToTop>
        <Layout>
          <Routes>
            <Route path={url.homePage} element={<Home />} />

            <Route path={url.login} element={<Login />} />
            <Route
              path={url.forgottenPasswordSendMail}
              element={<ForgottenPasswordSendMail />}
            />
            <Route
              path={url.forgottenAccountToken}
              element={<ForgottenPasswordUpdate />}
            />
            <Route path={url.thankYouPage} element={<ThankYouPage />} />

            <Route path={url.aboutUs} element={<AboutUs />} />
            <Route path={url.faq} element={<Faq />} />
            <Route path={url.regulations} element={<Regulations />} />
            <Route path={url.privacyPolicy} element={<PrivacyPolicy />} />
            <Route path={url.contact} element={<Contact />} />

            <Route path={url.offerForm} element={<OfferForm />} />
            <Route path={url.offerFormSummary} element={<OfferFormSummary />} />
            <Route path={url.offerCreate} element={<OfferFormCreate />} />
            <Route path={url.offerView} element={<OfferView />} />
            <Route
              path={url.offerInitialAcceptance}
              element={<OfferInitialAcceptance />}
            />
            <Route
              path={url.offerViewLinkEmailUnloggedClient}
              element={<OfferViewFromEmailClientUnlogged />}
            />
            <Route
              path={url.offerViewLinkEmailLoggedClient}
              element={<OfferViewFromEmailClientLogged />}
            />
            <Route
              path={url.finalOfferViewLinkEmailUnloggedClient}
              element={<FinalOfferFromEmailClientUnlogged />}
            />
            <Route
              path={url.finalOfferViewLinkEmailLoggedClient}
              element={<FinalOfferFromEmailClientLogged />}
            />
            <Route
              path={url.offerViewSubcontractor}
              element={<SubcontractorOfferView />}
            />
            {/* WIDOKI OPERATORA */}
            <Route
              path={urlOperator.clients}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorClients />
                </PrivateRoute>
              }
            />
            {/* <Route
              path={urlOperator.clientsAdd}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <ClientAddForm />
                </PrivateRoute>
              }
            /> */}
            <Route
              path={urlOperator.clientsEdit}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorClientsEdit />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.warehouseDelete}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorWarehouseDelete />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.warehousesPricelist}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorWarehousesPricelist />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.warehousesPricelistEdit}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorWarehousesPricelistEdit />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.warehousesPricelistAdd}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorWarehousesPricelistAdd />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.orders}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorOrders />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.ordersDetails}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorOrdersDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.ordersOffering}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorOrdersOffering />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.ordersOfferingPositionEdit}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OfferingPositionEdit />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.ordersOfferingPositionAdd}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OfferingPositionAdd />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.ordersOfferingOfferEdit}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OfferingOfferEdit />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.ordersOfferingPotentialWarehouses}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <PotentialWarehousesList />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractors}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorSubcontractors />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.warehouseGallery}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <WarehousesGalleryView />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractorsDetails}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorSubcontractorsDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractorsStorageArea}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <SubcontractorsStorageArea />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractorsStorageAreaAdd}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <StorageAreaAdd />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractorsStorageAreaEdit}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <StorageAreaEdit />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractorsStorageAreaAvailability}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <SubcontractorsStorageAreaAvailability />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractorsStorageAreaAvailabilityAdd}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <AddAvailabilityForm />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractorsStorageAreaAvailabilityEdit}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <UpdateAvailabilityForm />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractorsPackageAdd}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <StorageAreaPackageAdd />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractorsPackageEdit}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <StorageAreaPackageEdit />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.operatorUsers}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorUsers />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.operatorUsersAdd}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorUserAdd />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.operatorUsersLoginEdit}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <EditUserLogin />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.operatorUsersOperatorDataEdit}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <EditUserOperatorDataForm />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.operatorUsersSubcontractorDataEdit}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <EditUserSubcontractorData />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.warehouseServices}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorWarehousesServices />
                </PrivateRoute>
              }
            />
            <Route
              path={urlOperator.subcontractorsAddSubcontractor}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <OperatorSubcontractorsAdd />
                </PrivateRoute>
              }
            />
            {/* <Route
              path={urlOperator.adressAdd}
              element={
                <PrivateRoute roles={[UserRoles.OPERATOR]}>
                  <AddressAddForm />
                </PrivateRoute>
              }
            /> */}
            {/* WIDOKI KLIENTA */}
            <Route
              path={urlClient.orderForm}
              element={
                <PrivateRoute roles={[UserRoles.CLIENT]}>
                  <OfferFormLogged />
                </PrivateRoute>
              }
            />
            <Route
              path={urlClient.orderFormSummary}
              element={
                <PrivateRoute roles={[UserRoles.CLIENT]}>
                  <OfferFormSummaryLogged />
                </PrivateRoute>
              }
            />
            <Route
              path={urlClient.account}
              element={
                <PrivateRoute roles={[UserRoles.CLIENT]}>
                  <ClientAccount />
                </PrivateRoute>
              }
            />
            <Route
              path={urlClient.offerView}
              element={
                <PrivateRoute roles={[UserRoles.CLIENT]}>
                  <OfferView />
                </PrivateRoute>
              }
            />
            <Route
              path={urlClient.offerViewId}
              element={
                <PrivateRoute roles={[UserRoles.CLIENT]}>
                  <OfferViewInClientPanel />
                </PrivateRoute>
              }
            />
            <Route
              path={urlClient.finalOfferViewId}
              element={
                <PrivateRoute roles={[UserRoles.CLIENT]}>
                  <FinalOfferViewInClientPanel />
                </PrivateRoute>
              }
            />
            <Route
              path={urlClient.settings}
              element={
                <PrivateRoute roles={[UserRoles.CLIENT]}>
                  <Settings />
                </PrivateRoute>
              }
            />
            <Route
              path={urlClient.orders}
              element={
                <PrivateRoute roles={[UserRoles.CLIENT]}>
                  <ClientOrders />
                </PrivateRoute>
              }
            />
            <Route
              path={urlClient.orderDetails}
              element={
                <PrivateRoute roles={[UserRoles.CLIENT]}>
                  <ClientOrdersDetails />
                </PrivateRoute>
              }
            />
            {/* WIDOKI PODWYKONAWCY */}
            <Route
              path={urlSubcontractor.subcontractors}
              element={
                <PrivateRoute roles={[UserRoles.SUBCONTRACTOR]}>
                  <SubcontractorSubcontractors />
                </PrivateRoute>
              }
            />
            <Route
              path={urlSubcontractor.subcontractorsDetails}
              element={
                <PrivateRoute roles={[UserRoles.SUBCONTRACTOR]}>
                  <SubcontractorsDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={urlSubcontractor.subcontractorsStorageArea}
              element={
                <PrivateRoute roles={[UserRoles.SUBCONTRACTOR]}>
                  <SubcontractorStorageArea />
                </PrivateRoute>
              }
            />
            <Route
              path={urlSubcontractor.warehouseServices}
              element={
                <PrivateRoute roles={[UserRoles.SUBCONTRACTOR]}>
                  <WarehousesServices />
                </PrivateRoute>
              }
            />
            <Route
              path={urlSubcontractor.warehousesPricelist}
              element={
                <PrivateRoute roles={[UserRoles.SUBCONTRACTOR]}>
                  <WarehousesPricelist />
                </PrivateRoute>
              }
            />
            <Route
              path={urlSubcontractor.storageAreaAvailability}
              element={
                <PrivateRoute roles={[UserRoles.SUBCONTRACTOR]}>
                  <StorageAreaAvailability />
                </PrivateRoute>
              }
            />
            <Route
              path={urlSubcontractor.storageAreaAvailabilityAdd}
              element={
                <PrivateRoute roles={[UserRoles.SUBCONTRACTOR]}>
                  <AddAvailabilityForm />
                </PrivateRoute>
              }
            />
            <Route
              path={urlSubcontractor.storageAreaAvailabilityEdit}
              element={
                <PrivateRoute roles={[UserRoles.SUBCONTRACTOR]}>
                  <UpdateAvailabilityForm />
                </PrivateRoute>
              }
            />

            {/* PRZYGOTOWANE SCIEŻKI */}

            <Route path={url.offer} element={<Offer />} />

            {/* 
            <Route path={url.orders} element={<Orders />} />
            <Route path={url.settings} element={<Settings />} /> 
            <Route path={url.account} element={<Account />} />
            <Route path={url.help} element={<Help />} /> */}

            <Route path={url.rest} element={<NotFound />} />
          </Routes>
        </Layout>
      </ScrollToTop>
    </Router>
  );
};

export default App;
